<form [formGroup]="form" class="mt-3">
  <div class="flex flex-col mt-3">
    <label class="soft-label top required">{{
      '#WORKSHOP.DIALOGS.CREATE_TASK.CUSTOMER' | translate
    }}</label>
    <soft-value-converter formControlName="customer" [converter]="kundeConverter">
      <soft-field-ok
        name="ktostamm.kunde"
        [parameters]="parameters"
        [placeholder]="'#WORKSHOP.DIALOGS.CREATE_TASK.CUSTOMER' | translate"
        #convertValue
      >
      </soft-field-ok>
    </soft-value-converter>
    @if (form.controls['customer'].touched) {
      <soft-validation-container
        class="soft-property-validation"
        [validation]="form | validationMessage: 'customer'"
      ></soft-validation-container>
    }
  </div>
  <div class="flex flex-col mt-3">
    <label class="soft-label top required">{{
      '#WORKSHOP.DIALOGS.CREATE_TASK.TASK_TITLE' | translate
    }}</label>
    <soft-input
      [placeholder]="'#WORKSHOP.DIALOGS.CREATE_TASK.TASK_TITLE' | translate"
      formControlName="title"
    ></soft-input>
    @if (form.controls['title'].touched) {
      <soft-validation-container
        class="soft-property-validation"
        [validation]="form | validationMessage: 'title'"
      ></soft-validation-container>
    }
  </div>
  <div class="flex flex-col mt-3">
    <label class="soft-label top required">{{
      '#WORKSHOP.DIALOGS.CREATE_TASK.HEADER_TEXT' | translate
    }}</label>
    <soft-multiline-input
      [placeholder]="'#WORKSHOP.DIALOGS.CREATE_TASK.HEADER_TEXT' | translate"
      formControlName="headerText"
      [lines]="4"
    ></soft-multiline-input>
    @if (form.controls['headerText'].touched) {
      <soft-validation-container
        class="soft-property-validation"
        [validation]="form | validationMessage: 'headerText'"
      ></soft-validation-container>
    }
  </div>

  <div class="flex flex-col mt-3">
    <label class="soft-label top required">{{
      '#WORKSHOP.DIALOGS.CREATE_TASK.SELLING_METHOD' | translate
    }}</label>
    <soft-value-converter
      formControlName="sellingType"
      [converter]="verkaufsartwerkstattConverter"
    >
      <soft-field-ok
        name="verkaufsartwerkstatt"
        [parameters]="
          form.value?.customer
            ? { kzart: 'H', idkunde: form.value?.customer?.id }
            : { kzart: 'H' }
        "
        [placeholder]="'#WORKSHOP.DIALOGS.CREATE_TASK.SELLING_METHOD' | translate"
        #convertValue
      >
      </soft-field-ok>
    </soft-value-converter>
    @if (form.controls['sellingType'].touched) {
      <soft-validation-container
        class="soft-property-validation"
        [validation]="form | validationMessage: 'sellingType'"
      ></soft-validation-container>
    }
  </div>
  <div class="flex flex-col mt-3">
    <label class="soft-label top">{{
      '#WORKSHOP.DIALOGS.CREATE_TASK.VEHICLE' | translate
    }}</label>
    <soft-value-converter formControlName="vehicle" [converter]="fahrzeugConverter">
      <soft-field-ok
        name="fahrzeug"
        [parameters]="
          form.value.customer ? { idktostamm_kunde: form.value.customer.id } : {}
        "
        [placeholder]="'#WORKSHOP.DIALOGS.CREATE_TASK.VEHICLE' | translate"
        #convertValue
      >
      </soft-field-ok>
    </soft-value-converter>
    @if (form.controls['vehicle'].touched) {
      <soft-validation-container
        class="soft-property-validation"
        [validation]="form | validationMessage: 'vehicle'"
      ></soft-validation-container>
    }
  </div>
  <div class="justify-between flex flex-row flex-nowrap">
    <div class="flex flex-col mt-3 mr-2 w-full">
      <label class="soft-label top">{{
        '#WORKSHOP.DIALOGS.CREATE_TASK.KILOMETERS' | translate
      }}</label>
      <soft-number-input
        [placeholder]="'#WORKSHOP.DIALOGS.CREATE_TASK.KILOMETERS' | translate"
        formControlName="kilometersStart"
      ></soft-number-input>
      @if (form.controls['kilometersStart'].touched) {
        <soft-validation-container
          class="soft-property-validation"
          [validation]="form | validationMessage: 'kilometersStart'"
        ></soft-validation-container>
      }
    </div>

    <div class="flex flex-col mt-3 ml-2 w-full">
      <label class="soft-label top">{{
        '#WORKSHOP.DIALOGS.CREATE_TASK.OPERATING_HOURS' | translate
      }}</label>
      <soft-number-input
        [placeholder]="'#WORKSHOP.DIALOGS.CREATE_TASK.OPERATING_HOURS' | translate"
        formControlName="operatingHours"
      ></soft-number-input>
      @if (form.controls['operatingHours'].touched) {
        <soft-validation-container
          class="soft-property-validation"
          [validation]="form | validationMessage: 'operatingHours'"
        ></soft-validation-container>
      }
    </div>
  </div>
  <div class="flex items-center justify-end flex-nowrap mt-4 fill gap-4">
    <button class="soft-button accent" (click)="form.reset()">
      Formular zurücksetzen
    </button>
  </div>
</form>
